import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import AnswerSection from './formSections/answer';
import useInterviews from '../useInterviews';
import FormHelper from '../../../../../helpers/FormHelper';
import { useEffect, useMemo, useState } from 'react';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    shoppingCenters,
    handleCreateOrUpdateCategory,
    updateInProcess,
    typeInterview,
    setTypeInterview,
    companyCategories,
    answerCheckboxes,
    setAnswerCheckboxes,
  } = useInterviews(false, !isNew);
  const onFinish = async (values) => {
    values.company_category_ids = [];
    const checkboxGroup = document.querySelector('.checkbox_group');
    const checkboxArray = checkboxGroup?.querySelectorAll('input') || [];
    checkboxArray.forEach((checkbox) => {
      if (checkbox.checked) {
        values.company_category_ids.push(parseInt(checkbox.value, 10));
      }
    });
    await handleCreateOrUpdateCategory(values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('CREARE SONDAGGIO A RISPOSTA CHIUSA').toUpperCase()
    : t('MODIFICA EXTRASTOCK CONTRACTOR').toUpperCase();
  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            date_from: '',
            date_to: '',
            shopping_center_id: '',
            type_interview: '',
            interview_questions_attributes: [],
            company_category_ids: [],
            in_telegram: false,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={(field) => {
            FormHelper.resetFormsFieldErrors(form)(field);
            if (field[0] && field[0].name[2] === 'is_input_text') {
              if (field[0].value) {
                setAnswerCheckboxes({
                  ...answerCheckboxes,
                  [field[0].name[1]]: field[0].value,
                });
              } else {
                setAnswerCheckboxes({
                  ...answerCheckboxes,
                  [field[0].name[1]]: null,
                });
              }
            }
            if (field[0] && field[0].name[0] === 'type_interview') {
              setTypeInterview(field[0].value);
            }
          }}
        >
          <InfoSection
            typeInterview={typeInterview}
            shoppingCenters={shoppingCenters}
            companyCategories={companyCategories}
          />
          <AnswerSection answerCheckboxes={answerCheckboxes} form={form} />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
